import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { refreshPage, toastStyle } from "../../Helpers/Utils/Common";
import ReactLoading from "react-loading";
import { Input, Row, Col, Button, Select } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import kaffeAldeLogo from "../../Assets/Images/logo.png"
import rightLoginLogo from "../../Assets/Images/logo.png"
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";

//css
import "./LoginAdmin.css";

//api
import { loginUser } from "../../Helpers/apiCalls/authApi";
import MytFooter from "../../Components/MytFooter";

export default function LoginAdmin() {
    const {terminal} = useParams();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    // const [showPassword, setShowPassword] = useState(false);
    const [disableClick, setDisableClick] = useState(false);
    const [userOptions, setUserOptions] = useState([]);
    // const adminPages = ["CLI","MEN","CAT", "DIS", "USR", "RCR", "CTR", "EJO", "SAL", "PMR", "ITH", "SCS", "PWD", "ODS", "CCR", "CSC", "ADT", "XRE", "FNR", "RIS", "ORP","ADP","ACC"]
    // const cashierPages = ["CTR", "SAL", "PMR", "ITH", "SCS", "PWD", "ODS", "CCR", "CSC", "XRE", "RIS", "ORP","ADP","ACC"]
  

    // const togglePassword = () => {
    //     setShowPassword(!showPassword);
    // };

    let navigate = useNavigate();

    async function submit() {
        setDisableClick(true);
        const response = await loginUser(username, password, terminal);
        if (response.data) {
            // if (response.data.role_id==="1"||response.data.role_id==="7") {
            //     localStorage.setItem(
            //       "permissions",
            //       JSON.stringify(adminPages)
            //     );
            //   } else {
            //     localStorage.setItem(
            //       "permissions",
            //       JSON.stringify(cashierPages)
            //     );
            //   }
            localStorage.setItem("user", JSON.stringify(response.data.id));
            localStorage.setItem(
                "full_name",
                JSON.stringify(response.data.full_name)
            );
            localStorage.setItem(
                "username",
                JSON.stringify(response.data.username)
            );
            localStorage.setItem(
                "role_id",
                JSON.stringify(response.data.role_id)
            );
            localStorage.setItem(
                "permissions",
                JSON.stringify(response.data.permissions.map((data)=> {return data.permission_id}))
                
            );
            localStorage.setItem("zreading", JSON.stringify(response.data.is_zcounter));
            localStorage.setItem("token", JSON.stringify(response.data.token));
            toast.success("Successful Login!", { style: toastStyle() });
            setTimeout(() => {
                if(response.data.role_id==="1"||response.data.role_id==="7"){
                    navigate("/closedinvoices")
                    refreshPage()
                }
                if(response.data.role_id==="2"){
                    navigate("/orderingpage")
                    refreshPage()
                }
                if(response.data.role_id==="8"){
                    navigate("/sales-report")
                    refreshPage()
                }
                if(response.data.role_id==="3"){
                    navigate("/ordersUpdate")
                    refreshPage()
                }
                if(response.data.role_id==="4"){
                    navigate("/dispatcher/orders")
                    refreshPage()
                }
                if(response.data.role_id==="5"){
                    navigate("/orderingpage")
                    refreshPage()
                }
            }, 2000);
        } else if (response.error) {
            toast.error(response.error.data.messages.error, {
                style: toastStyle(),
            });
            setTimeout(function () {
                // refreshPage();
                setDisableClick(false);
            }, 2000);
        }
    }
    
    async function fetchAllUsers() {
        const response = await UseGetRequest("users/search", {});
        if (response.data) {
            const res = response.data.map((row) => {
            return {
                value: row.username,
                label: row.username,
            };
            });
            setUserOptions(res);
        } else {
            setUserOptions([]);
        }
    }
    
    React.useEffect(() => {
    fetchAllUsers();
    }, []);

    return(
        <div className="row login-container p-2">
           <Col 
                className="login-left-side center"
                xs={24} sm={24} md={24} lg={12} xl={12}
            >
                <img
                src={kaffeAldeLogo}
                alt={"logo"}
                className="login-logo"
                ></img>
            </Col>
            <Col 
                className="login-right-side p-5" 
                xs={24} sm={24} md={24} lg={12} xl={12}
            >
                <Row className="center">
                    <Col sm={12} className="login-logo-two center">
                        <img
                            src={rightLoginLogo}
                            alt="logo"
                            width={150}
                            height='auto'
                        />
                    </Col>
                </Row>
                <Row className="mt-3 center">
                    <Col span={13} className="custom-select-container center">
                        <UserOutlined className="custom-select-icon"/>
                        <Select
                            suffixIcon={null}
                            placeholder="Username"
                            options={userOptions}
                            showSearch
                            filterOption={(input, option) =>
                            option.label?.toLowerCase().includes(input?.toLowerCase())
                            }
                            onChange={(e) => setUsername(e)}
                            autoComplete="off"
                            // autoComplete="new-password"
                        />
                    </Col>
                </Row>
                <Row className="mt-2 center">
                    <Col span={13} className="center">
                        <Input.Password
                        className="login-input"
                        prefix={<LockOutlined />}
                        type="password"
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={(e) =>
                            e.key === ("Enter" || "NumpadEnter") && submit()
                        }
                        />
                    </Col>
                </Row>
                <Row className="mb-4">
                    <div className="col d-flex justify-content-center mt-3">
                        {disableClick === true && (
                        <ReactLoading
                            type="spinningBubbles"
                            color="#2a9d3a"
                            height={50}
                            width={50}
                        />
                        )}
                        {disableClick === false && (
                        <div>
                            <Row className="d-flex justify-content-center">
                                <Col span={24} className="d-flex justify-content-center">
                                    <Button
                                        type="primary"
                                        className="w-100 login-btn"
                                        onClick={() => submit()}
                                    >
                                        LOGIN
                                    </Button>
                                </Col>
                            </Row>
                            {/* <Row className="d-flex justify-content-center mt-5">
                        <Col xs={6} className="d-flex justify-content-center">
                            <Button
                            type="danger"
                            className="exit-button"
                            onClick={() => {
                                localStorage.clear();
                                window.open('/', '_self', '');
                                window.close('/');
                            }}
                            >
                            EXIT WINDOW
                            </Button>
                        </Col>
                        </Row> */}
                        </div>
                        )}
                    </div>
                </Row>
                <MytFooter/>
            </Col>
        </div>
      );
}